module.exports = __webpack_public_path__ + "img/e1.dbaaa867.jpg";